import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

export type CustomSearchResultType = {
    activeTab: string;
};

const initialState: CustomSearchResultType = {
    activeTab: "products",
};

const reducer = {
    "Custom/SearchResults/SetActiveTab": (draft: Draft<CustomSearchResultType>, action: { activeTab: string }) => {
        draft.activeTab = action.activeTab;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
